import './index.less';
import './home.less';
import './list.less';
import './project.less';
import './project-app.less';
import './scheme.less';
import './order.less';
import './collect.less';
import './init.less';
import './reward.less';
import './price.less';
import './mode.less';
import './search.less';
import './app.less';
import './main.less';
import './ecode.less';
import './ecodeWf.less';
import './mobileMode.less';
import './font/style.css';
import './workflow.less';
import './fonticon/symbol'



// WEBPACK FOOTER //
// ./src/style/index.js